/* Боковая панель. В светлой теме светлая, в тёмной — тёмно-синяя:
   цвета берутся из переменных --side-* (styles/tokens.css). */

.nav {
  position: relative;
  z-index: 200;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 236px;
  height: 100%;
  padding: 22px 14px 14px;
  color: var(--side-text);
  background: var(--side-bg);
  border-right: 1px solid var(--side-border);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 8px 18px;
  font-size: 17px;
  font-weight: 650;
  letter-spacing: -.01em;
  color: var(--side-strong);
}

.brandMark { flex-shrink: 0; }

.searchFull { margin-bottom: 14px; }

.tabs {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;
}

.tabs::-webkit-scrollbar { display: none; }

.tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  height: 40px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: inherit;
  text-decoration: none;
  white-space: nowrap;
  background: none;
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
  transition: background .15s, color .15s;
}

.tab:hover { color: var(--side-strong); background: var(--side-hover); }

.tabActive,
.tabActive:hover {
  color: var(--side-strong);
  background: var(--side-active-bg);
  box-shadow: inset 3px 0 0 var(--side-active);
}

.tabActive svg { color: var(--side-active); }

.tabLabel { overflow: hidden; text-overflow: ellipsis; }

/* Поиск значком — только в свёрнутой панели */
.searchButton { display: none; }
.searchButtonEnd { display: none; }

/* Значок у раздела: сколько ждёт действия именно этого пользователя */
.tabBadge {
  min-width: 20px;
  margin-left: auto;
  padding: 0 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: #fff;
  background: #DC2626;
  border-radius: var(--r-pill);
}

.user {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding: 10px;
  color: inherit;
  text-align: left;
  background: none;
  border: none;
  border-top: 1px solid var(--side-border);
  border-radius: 0;
  cursor: pointer;
}

.user:hover .userName { text-decoration: underline; text-underline-offset: 3px; }

.avatar {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  font-size: 13px;
  font-weight: 650;
  color: #fff;
  background: var(--blue) center / cover no-repeat;
  border-radius: 50%;
}

.userText { display: flex; flex-direction: column; min-width: 0; }

.userName {
  overflow: hidden;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--side-strong);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userRole { font-size: 12px; color: var(--side-muted); }

/* ── Всплывающий поиск свёрнутой панели ── */

.scrim {
  position: fixed;
  inset: 0;
  z-index: 390;
  background: var(--scrim);
  border: none;
}

.searchPopover {
  position: fixed;
  top: 16px;
  left: 88px;
  z-index: 400;
  width: min(460px, calc(100vw - 104px));
  padding: 12px;
  background: var(--card-bg);
  border-radius: var(--r-md);
  box-shadow: 0 16px 40px rgba(15, 23, 42, .3);
}

/* ── Планшет: только значки ── */

@media (max-width: 1179px) {
  .nav { width: 72px; padding: 18px 10px 12px; }

  /* Знак отделён линией от значков: под ним сразу лупа поиска */
  .brand { justify-content: center; margin-bottom: 12px; padding: 0 0 14px; border-bottom: 1px solid var(--side-border); }
  .brandFull { display: none; }

  .searchFull { display: none; }
  .searchButton { display: flex; }

  .tab { justify-content: center; padding: 0; }
  .tabLabel { display: none; }

  .tabBadge {
    position: absolute;
    top: 2px;
    right: 2px;
    min-width: 18px;
    padding: 0 4px;
    font-size: 10px;
    line-height: 18px;
  }

  .user { justify-content: center; padding: 10px 0 0; }
  .userText { display: none; }
}

/* ── Телефон: полоса сверху ── */

@media (max-width: 699px) {
  .nav {
    border-right: none;
    border-bottom: 1px solid var(--side-border);
    flex-direction: row;
    align-items: center;
    gap: 4px;
    width: 100%;
    height: 52px;
    padding: 0 8px;
  }

  .tabs {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .tab { width: 42px; height: 42px; }

  .brand { margin: 0; padding: 0 8px 0 2px; border-bottom: none; }
  .searchButton { display: none; }
  .searchButtonEnd { display: flex; flex-shrink: 0; margin-left: auto; }

  .tabActive,
  .tabActive:hover { box-shadow: inset 0 -3px 0 var(--side-active); }

  .user { margin: 0; padding: 0 0 0 6px; border: none; }
  .avatar { width: 32px; height: 32px; font-size: 12px; }

  .searchPopover { top: 60px; left: 8px; right: 8px; width: auto; }
}
